import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

interface Props {
  isActive?: boolean;
  isTeamContainer?: boolean;
  isMiddleContainer?: boolean;
  isDeleteIconHover?: boolean;
  isNewRow?: boolean;
  isDelete?: boolean;
}

const Group = styled.form<Props>`
  width: 100%;
  max-width: 662px;
  margin: auto;
  margin-bottom: 24px;
`;
const Container = styled.div`
  background-color: var(--background-secondary);
`;

const Icon = styled.div<Props>`
  position: relative;
  display: flex;
  cursor: pointer;

  .more-icon {
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
    :hover {
      background: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
  .profile-image {
    border-radius: var(--border-radius-full);
    width: 58px;
    height: 58px;
    object-fit: cover;
  }
  .empty-profile-image {
    border-radius: var(--border-radius-full);
    width: 60px;
    height: 60px;
    object-fit: cover;
  }
  &.profile-image-container {
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-full);
  }
  :hover {
    .edit-profile {
      display: flex;
    }
    .profile-image {
      filter: blur(1.5px);
      -webkit-filter: blur(1.5px);
    }
    .empty-edit-profile {
      display: flex;
    }
  }

  ${(props: Props) =>
    props.isDeleteIconHover &&
    css`
      padding: 3px;
      align-items: center;
      justify-content: center;
      :hover {
        background-color: var(--neutral-secondary);
        border-radius: var(--border-radius-4);
      }
      ${mobile_xl(css`
        padding: 6px;
        svg {
          width: 20px;
          height: 20px;
        }
      `)}
    `}
`;

const SvgIconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-4);
  padding: 4px;
  :hover {
    background-color: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    padding: 3px;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const Details = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  align-items: flex-start;
  ${(props) =>
    props.isDelete &&
    css`
      gap: 12px;
    `}
  ${mobile_xl(css`
    margin-block: 8px 80px;
  `)}
`;

const Title1 = styled.h2`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: 0;
`;

const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
`;

const Userprofile = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  ${mobile_xl(css`
    &.invoice {
      padding-inline: 20px;
    }
  `)}
`;

const Uploadtext = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${mobile_xl(css`
    gap: 2px;
  `)}
`;

const Title2 = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: 0;
  cursor: pointer;
`;

const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  ${mobile_xl(css`
    gap: 16px;
  `)}
`;

const FormBlock = styled.div<Props>`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  ${(props: Props) =>
    props.isNewRow &&
    css`
      flex-direction: column;
    `}
  ${mobile_xl(css`
    gap: 16px;
    width: 100%;
  `)}
`;

const Form = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  ${mobile_xl(css`
    width: 100%;
  `)}
  .angleDown-icon {
    path {
      stroke: var(--text-primary);
    }
  }
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const InputDiv = styled.div`
  position: relative;
  color: var(--text-primary);
  :focus-within .angleDown-icon {
    display: none;
  }
`;

const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 8px;
  right: 10px;
`;

const InputValue = styled.input`
  width: 234px;
  ${Typography.body_lg}
  color: var(--text-primary);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  padding: 7px 12px;
  outline: none;
  :placeholder {
    color: var(--text-placeholder);
  }
  :focus {
    border: 0.5px solid var(--brand-primary);
    z-index: 999;
  }
  ${mobile_xl(css`
    width: -webkit-fill-available;
  `)}
`;

const ProjectContent = styled.div<Props>`
  max-width: 662px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  margin: auto;
  border-radius: var(--border-radius-8);
  margin-bottom: 45px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  ${mobile_xl(css`
    margin-block: 8px 80px;
  `)}
`;

const SubContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 20px;
  ${mobile_xl(css`
    gap: 20px;
    padding: 20px 0;
  `)}
`;

const InputNameTitle = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const InputAddressTitle = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin-top: 10px;
`;

const Autotext = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 532px;
  width: 100%;

  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--brand-primary);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    top: 1px;
    left: 1px;
    background-color: var(--text-white);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: var(--brand-primary);
  }

  input:focus + .slider {
    box-shadow: 0 0 1px var(--brand-primary);
  }

  input:checked + .slider:before {
    transform: translateX(20px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: var(--border-radius-full);
  }

  .slider.round:before {
    border-radius: var(--border-radius-full);
  }
  ${mobile_xl(css`
    border-bottom: 0.5px solid var(--border-primary);
    padding: 0 20px 20px;
    width: calc(100% - 40px);
  `)}
`;

const Title4 = styled.h5`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: 0;
`;

const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-top: 6px;
  background-color: var(--background-tertiary);
  border-radius: var(--border-radius-4);
  gap: 6px;
  ${mobile_xl(css`
    padding: 0;
    margin-top: 10px;
    background-color: unset;
  `)}
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px;
  margin-top: 6px;
  background-color: var(--background-tertiary);
  border-radius: var(--border-radius-4);
  ${mobile_xl(css`
    padding: 0;
    margin-top: 10px;
    background-color: unset;
  `)}
`;

const NameInput = styled.input`
  ${Typography.body_md}
  color: var(--text-primary);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  padding: 5px 12px;
  outline: none;

  :focus {
    border: 0.5px solid var(--brand-primary);
  }
  ::placeholder {
    color: var(--border-secondary);
  }
`;

const InputSide = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  .label {
    margin-bottom: 20px;
  }

  .note {
    width: 450px;
  }
  p {
    ${Typography.body_md}
    color: var(--text-secondary);
    margin: 0;
  }
`;

const InputValue1 = styled.input`
  ${Typography.body_md}
  color: var(--text-primary);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  padding: 5px 12px;
  outline: none;

  &.first {
    width: 308px;
  }
  &.second {
    width: 110px;
  }
  :focus {
    border: 0.5px solid var(--brand-primary);
  }
  ::placeholder {
    color: var(--border-secondary);
  }

  ${mobile_xl(css`
    &.first {
      width: 50%;
    }
    &.second {
      width: 30%;
    }
  `)}
  &[type='number'] {
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

const AddTask = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const Text1 = styled.p`
  ${Typography.body_md_medium}
  color: var(--brand-primary);
  margin: 0;
  cursor: pointer;
  display: inline-flex;
`;

const Features = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${mobile_xl(css`
    gap: 8px;
    padding-inline: 20px;
  `)}
`;
const InvoiceDue = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${mobile_xl(css`
    gap: 4px;
  `)}
`;

const PaymentContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PaymentBlock = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
`;

const Title5 = styled.h5`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: 0;
`;

const TextBlocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Text2 = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
`;

const Text3 = styled.a`
  ${Typography.body_md_medium}
  color: var(--brand-primary);
  margin: 0;
  text-decoration: none;
  width: fit-content;
`;

const Text4 = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
  span {
    font-weight: 700;
  }
`;

const Tax = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Teammate = styled.div`
  padding: 13px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
  .pending {
    opacity: 0.6;
  }
  ${mobile_xl(css`
    padding: 12px 16px;
    gap: 12px;
  `)}
`;
const PersonInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TeammateName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  h1 {
    ${Typography.body_lg_medium}
    color: var(--text-primary);
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    word-break: break-all;
  }
  p {
    ${Typography.body_md}
    color: var(--text-secondary);
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    word-break: break-all;
  }
`;

const PendingButton = styled.button`
  padding: 2px 5px;
  ${Typography.body_sm}
  color: var(--text-secondary);
  background: var(--border-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  ${mobile_xl(css`
    padding-block: 0;
  `)}
`;
const PersonalText = styled.div`
  ${Typography.heading_lg}
  color: var(--text-primary);
`;
const PersonalHeader = styled.div<Props>`
  max-width: 662px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto 12px;
  gap: 30px;
  ${mobile_xl(css`
    margin: 0;
    padding: 20px 0 12px;
  `)}
`;
const SubmitBtn = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const ProfileInfo = styled.div`
  max-width: 662px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  gap: 20px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  ${mobile_xl(css`
    margin-block: 8px 80px;
  `)}
`;
const NotificationContent = styled.div`
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  ${mobile_xl(css`
    border: unset;
  `)}
`;
const NotificationDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  ${mobile_xl(css`
    gap: 4px;
  `)}
`;
const Pending = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  align-items: center;
  .active {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
`;

const AdminText = styled.div`
  padding: 2px 5px;
  ${Typography.body_sm}
  color: var(--text-secondary);
  background: var(--border-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  ${mobile_xl(css`
    padding-block: 0;
  `)}
`;

const RightDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  .active {
    display: flex;
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
`;
const Top = styled.div`
  border-radius: var(--border-radius-6);
  border: 1px solid var(--neutral-secondary);
  background: var(--neutral-secondary);
  color: var(--text-secondary);
  ${Typography.body_sm}
  padding: 2px 6px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Middle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const ConnectBtn = styled.div`
  padding: 3px 8px;
  border-radius: var(--border-radius-6);
  border: 1px solid var(--neutral-secondary);
  background: var(--neutral-secondary);
  color: var(--brand-primary);
  ${Typography.body_md_medium}
`;
const MainForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;

const Inputfield = styled.textarea`
  height: 100px;
  padding: 5px 12px;
  ${Typography.body_md}
  color: var(--text-primary);
  font-family: unset;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  resize: none;
  outline: none;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  :focus {
    border: 0.5px solid var(--brand-primary);
  }

  ::placeholder {
    ${Typography.body_md}
    color: var(--text-secondary);
  }
`;
const ProjectHeadingTop = styled.div`
  padding: 11px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  .checkbox-round {
    width: 7px;
    height: 7px;
    border-radius: var(--border-radius-full);
    vertical-align: middle;
    border: 1px solid var(--border-secondary);
    appearance: none;
    outline: none;
    cursor: pointer;
    margin: 0;
    padding: 7px;
    ${mobile_xl(css`
      padding: 8px;
    `)}
  }
  input[type='checkbox'] {
    position: relative;
    cursor: pointer;
    opacity: 0.5;
  }
  input[type='checkbox']:checked {
    background-color: var(--brand-primary);
    opacity: 1;
    border: 1px solid var(--brand-primary);
  }
  input[type='checkbox']:checked::before {
    content: '';
    position: absolute;
    right: 50%;
    top: 50%;
    width: 3px;
    height: 8px;
    border: solid var(--text-white);
    border-width: 0 2px 2px 0;
    margin: -0.5px -1px 0 -1px;
    transform: rotate(45deg) translate(-50%, -50%) scale(0.7);
    z-index: 2;
  }
  ${mobile_xl(css`
    padding-inline: 0;
  `)}
`;
const TitleText = styled.h4`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: 0;
`;
const PlusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header = styled.div`
  ${mobile_xl(css`
    display: flex;
    align-items: center;
    gap: 24px;
  `)}
`;

const SelectedText = styled.div`
  position: absolute;
  top: 8px;
  left: 15px;
  pointer-events: none;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 218px;
  width: 100%;
  white-space: nowrap;
  ${Typography.body_lg}
`;
const Overlay = styled.div`
  background-color: var(--background-hover);
  top: 0;
  left: 0;
  width: 58px;
  height: 58px;
  position: absolute;
  display: none;
  justify-content: center;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  &.empty-edit-profile {
    width: 60px;
    height: 60px;
  }
`;
const EditIcon = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  .edit-icon {
    path {
      stroke: var(--text-white);
      fill: none;
    }
  }
`;

const NotificationForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${mobile_xl(css`
    width: calc(100% - 40px);
    padding: 8px 20px 20px;
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-8);
    gap: 12px;
    margin-block: 8px 80px;
    .button {
      width: max-content;
    }
  `)}
`;

// general/organisation profile screen
const OrganizationForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${mobile_xl(css`
    margin-block: 8px 80px;
    gap: 24px;
  `)}
`;
const OrganizationFormDetails = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  align-items: flex-start;
  ${(props) =>
    props.isDelete &&
    css`
      gap: 12px;
    `}
`;
const OrganizationDeleteBlock = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  ${mobile_xl(css`
    gap: 4px;
    width: 100%;
  `)}
`;

// invoice
const RadioButtonWrapper = styled.div`
  ${mobile_xl(css`
    padding-block: 10px;
  `)}
`;
const InvoiceLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-full);
  width: 40px;
  height: 40px;
  img {
    border-radius: var(--border-radius-full);
    object-fit: contain;
  }
  ${mobile_xl(css`
    width: 60px;
    height: 60px;
    img {
      width: 60px;
      height: 60px;
    }
  `)}
`;

export {
  Header,
  InputSection,
  NameInput,
  InputNameTitle,
  InputAddressTitle,
  Group,
  Container,
  Icon,
  Details,
  Title1,
  Text,
  Userprofile,
  Uploadtext,
  Title2,
  FormBlock,
  Form,
  Label,
  InputValue,
  ProjectContent,
  SubContent,
  Autotext,
  Title4,
  FormContent,
  InputSide,
  InputValue1,
  AddTask,
  Text1,
  Features,
  PaymentContent,
  PaymentBlock,
  Title5,
  Text2,
  Text3,
  Text4,
  Tax,
  Teammate,
  PersonInfo,
  TeammateName,
  PendingButton,
  SubmitBtn,
  PersonalText,
  PersonalHeader,
  ProfileInfo,
  NotificationDiv,
  NotificationContent,
  Pending,
  AdminText,
  RightDiv,
  Top,
  Middle,
  TextBlocks,
  Row,
  ConnectBtn,
  MainForm,
  InvoiceDue,
  Inputfield,
  ProjectHeadingTop,
  TitleText,
  PlusIcon,
  InputDiv,
  IconDiv,
  SelectedText,
  Overlay,
  EditIcon,
  FormSection,
  NotificationForm,
  SvgIconDiv,
  OrganizationForm,
  OrganizationFormDetails,
  OrganizationDeleteBlock,
  RadioButtonWrapper,
  InvoiceLogo
};
